<!-- Header -->
<div class="px-4 sm:px-8 pt-6 pb-2">
  <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px; flex-shrink: 0;">currency_bitcoin</mat-icon>
      Beneficiarios Criptomoneda
      <span *ngIf="listaCuentas.length > 0" class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
        {{ listaCuentas.length }} {{ listaCuentas.length === 1 ? 'beneficiario' : 'beneficiarios' }}
      </span>
    </h1>
    <button type="button" (click)="openCreateDialog()"
      style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white; flex-shrink: 0;">add_circle</mat-icon>
      Agregar Beneficiario
    </button>
  </div>
  <!-- Badge mobile -->
  <span *ngIf="listaCuentas.length > 0" class="md:hidden inline-block text-xs font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2">
    {{ listaCuentas.length }} {{ listaCuentas.length === 1 ? 'beneficiario' : 'beneficiarios' }}
  </span>
</div>

<!-- Empty state -->
<div *ngIf="listaCuentas.length === 0" class="px-4 sm:px-8 py-8">
  <div style="background: white; border-radius: 16px; padding: 48px 24px; text-align: center; border: 2px dashed #d1d5db;">
    <mat-icon style="font-size: 56px; width: 56px; height: 56px; color: #9ca3af; margin-bottom: 16px; flex-shrink: 0;">account_balance_wallet</mat-icon>
    <p style="font-size: 1.1rem; font-weight: 600; color: #374151; margin: 0 0 6px;">No tienes beneficiarios registrados</p>
    <p style="font-size: 0.85rem; color: #6b7280; margin: 0;">Agrega tu primer beneficiario para realizar envíos de criptomonedas</p>
  </div>
</div>

<!-- Lista -->
<app-recipient-cripto-list
  [listaCuentas]="listaCuentas"
  [estadoRedes]="estadoRedes"
  [seleccionable]="seleccionable"
  (seleccion)="onSeleccion($event)"
  (reloadAccountList)="reloadAccount()"
  (actualizarCuenta)="openCreateDialog($event)">
</app-recipient-cripto-list>
